import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import "../CompanyManagement/CustomerManagement.css";
import { useTranslation } from 'react-i18next';
import { IDebitData } from "../../../interfaces/IDebitData";
import i18n from "../../../i18n";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import AddCampus from "../CampusManagement/AddCampus";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { borderRadius } from "@mui/system";
import { FilePdfOutlined } from "@ant-design/icons";

export interface IDebit {
  count?: number;
  data?: IDebitData[];
}

const DebitManagement: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const { userId } = useParams<any>();
  const { t } = useTranslation();
  const [debitData, setDebitData] = useState<IDebit>({});
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const dataGridRef = useRef<any>(null);

  const pageData: IPageData = {
    title: t('debit_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    Debitfilter({ page: 1, pageSize: 10 });
  }, [i18n.language]);

  const columns: IMUIDataGridColumns[] = [
    { title: t('barcode'), key: 'barcode', placeHolder: t('barcode'), align: 'center', headerAlign: 'center' },
    { title: t('inventoryName'), key: 'inventoryName', placeHolder: t('inventoryName'), align: 'center', headerAlign: 'center' },
    { title: t('campus'), key: 'campusName', placeHolder: t('campus'), align: 'center', headerAlign: 'center' },
    { title: t('location'), key: 'locationName', placeHolder: t('location'), align: 'center', headerAlign: 'center' },
  ];

  const handleRowSelection = (newSelection: any) => {
    setSelectedRows(newSelection);
  };

  const pdfDownload = () => {
    if (selectedRows.length === 0) {
      toast.error(t('NoRows'));
      return;
    }

    const filteredData = selectedRows.map(row => ({
      inventoryName: row.inventoryName,
      barcode: row.barcode,
      debit: row.debit
    }));


    HTTPService.POSTblob('/Report/PdfDownloadDebit', filteredData)
      .then((response) => {
        if (response.status === 200) {
          toast.success(t('pdfSuccess'));
        } else if (response.status === 452) {
          toast.error(t('licenceExpiredDate'));
        } else if (response.status === 453) {
          toast.error(t('licenceNotfound'));
        } else {
          toast.error(t(response.data));
        }
      })
      .catch(() => {
        toast.error(t('error'));
      });
  };



  const Debitfilter = (e) => {
    const filters = e?.filters;
    const body = {
      pageSize: e?.pageSize,
      page: e?.page,
      ...filters
    };



    HTTPService.POST(`/Inventory/filtersdebit?userId=${userId}`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setDebitData(response.data);
      } else if (response.status != 450) {
        toast.error(response.data);
      }
    });
  }

  return (
    <>
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            onClick={pdfDownload}
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 10px',
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
          >
            <FilePdfOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('debit_document')}
            </span>
          </Button>
        </div>
      </div>
      <div className="row">
      </div>
      <div className="row">
        <div className="col-md-13">
          <MUIDatagrid enableSelection={true} ref={dataGridRef} data={debitData.data} total={debitData.count} columns={columns} onSelectionChange={handleRowSelection} onChange={Debitfilter} filterMode="server" />
        </div>
      </div>
    </>
  );
};

export default DebitManagement;
